import deburr from "lodash/deburr";

export default (text: string, separator = "-") => {
    const cleanupRegex = new RegExp(`^${separator}|${separator}$`, "g");

    return deburr(text.toLowerCase()).replace(/\W+/g, separator).replace(cleanupRegex, "");
};
